export default {
  heroTitle: 'Безопасность без лишнего',
  heroBody:
    'Laplace учитывает права подключённых систем, ограничивает доступ границами workspace и сохраняет источники под ответами.',

  pillarResidencyTitle: 'Варианты поставки',
  pillarResidencyBody:
    'Cloud, Hybrid и On-Premises подбираются под требования организации.',
  pillarComplianceTitle: 'Договорные требования',
  pillarComplianceBody:
    'Требования к обработке данных и безопасности фиксируются в договоре и сопроводительных документах.',
  pillarLlmTitle: 'Контроль AI-контура',
  pillarLlmBody:
    'Конфигурация AI согласуется с выбранной моделью поставки до запуска.',
  pillarAccessTitle: 'Права сохраняются',
  pillarAccessBody: 'Нет доступа у плагина — нет данных в ответе.',
  pillarSourcesTitle: 'Ответы проверяемы',
  pillarSourcesBody:
    'Под ответом остаются ссылки на документы, тикеты или переписки.',
  pillarAuditTitle: 'Журнал действий',
  pillarAuditBody: 'Администраторы видят ключевые запросы и действия.',

  permissionsEyebrow: 'Права доступа',
  permissionsTitle: 'Workspace видит только доступное плагину',
  permissionsBody:
    'Laplace работает в рамках прав account, которым плагин подключили к workspace.',
  permissionsItem1: 'Доступ ограничен ролью подключённого account',
  permissionsItem2: 'Закрытые разделы не попадают в контекст ответа',
  permissionsItem3: 'Плагин и документ видны под ответом',
  demoCaption: 'Один вопрос — два workspace',
  demoQuestion: 'Что изменилось в квартальном финансовом отчёте?',
  demoAllowedBadge: 'Workspace 1 · доступ к Finance',
  demoAllowedAnswer: 'В отчёте обновлены выручка, расходы и прогноз по марже.',
  demoAllowedSource: 'Плагин: Confluence · Finance',
  demoDeniedBadge: 'Workspace 2 · без доступа к Finance',
  demoDeniedAnswer: 'Плагин этого workspace не видит финансовый раздел.',

  ctaTitle: 'Нужен закрытый контур?',
  ctaBody: 'Обсудим требования безопасности и подходящий вариант поставки.',
  ctaButton: 'Обсудить поставку',
}
